import gsap from 'gsap';
import RytmWebflow from 'rytm-webflow'
import { lenis } from '../scrolling';

import {
  classNames,
  OBJECT_SCROLL_DISTANCE,
  VISIBLE_ON_START,
} from '../constants';
import { scrollToTargetForce } from '../scrolling';

class ObjectListView extends RytmWebflow.View {

  constructor(id) {
    super(id);
  }
  /**
  * animate in (show)
  **/
  show(container) {
    super.show(container);
    this.container = container;
    this.initScrollTriggers();
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    this.container = container;
    super.hide(container);
  }
  /**
   * #######################
   * ### Scroll Triggers ###
   */
  initScrollTriggers = () => {
    const container = this.container;
    // toggle active class
    gsap.to(container, {
      scrollTrigger: {
        trigger: container,
        start: 'top top',
        end: OBJECT_SCROLL_DISTANCE + 'px', // relative to start
        toggleClass: classNames.OBJECT_ACTIVE,
        toggleActions: "play none none reverse",
        // markers: true,
      },
    });
    this.initImageScroll();
  }
  // image animations
  initImageScroll = () => {
    // get element order in parent Node
    const index = Array.from(this.container.parentNode.children).indexOf(this.container);
    if (index >= VISIBLE_ON_START) {
      this.initImageScrollWrapper1();
      this.initImageScrollWrapper2();
    } else {
      this.initImageScrollWrapperIntro(index);
    }
    if (index > 0) {
      this.initImageScrollWrapper3();
    }
    // is this the last object (scroll to NEXT CHAPTER LINK)?
    const isLast = index == this.container.parentNode.children.length - 1;
    this.initImageScrollWrapper4(isLast);
  }

  // ## Image Wrapper INTRO animate to position 3 (from alpha 0)
  initImageScrollWrapperIntro = (index) => {
    const imageWrapper1 = this.container.querySelector('.image-wrapper-1');
    if (!imageWrapper1) return;
    let y = "-10%";
    let scale = 1.8;
    switch (index) {
      case 1:
        y = "-7%";
        scale = 1.7;
        break;
      case 2:
        y = "-34%";
        scale = 1.2;
        break;
    }
    gsap.set(imageWrapper1, {
      scale,
      y,
    });
    // wrapper 1 animate to position 3 (from alpha 0)
    gsap.to(imageWrapper1, {
      scrollTrigger: {
        trigger: '.chapter-objects',
        toggleActions: "play none none reverse",
        start: 'top 300px',
        end: 'top top',
        scrub: true,
        // markers: true,
      },
      scale: 1,
      y: "0%",
      duration: .5,
      ease: 'power1.inOut',
    });
  }
  // ## Image Wrapper 1 animate to position 3 (from alpha 0)
  initImageScrollWrapper1 = () => {
    const imageWrapper1 = this.container.querySelector('.image-wrapper-1');
    if (!imageWrapper1) return;
    gsap.set(imageWrapper1, {
      scale: .8,
      y: "-10%",
      autoAlpha: 0,
      visibility: 'hidden',
    });
    // wrapper 1 animate to position 3 (from alpha 0)
    gsap.to(imageWrapper1, {
      scrollTrigger: {
        trigger: this.container,
        toggleActions: "play none none reverse",
        start: '-' + OBJECT_SCROLL_DISTANCE * 2 + 'px top',
        end: 'top top',
        // markers: true,
        scrub: true,
        onEnter: () => {
          this.onObjectVisible();
        },
      },
      scale: 1,
      y: "0%",
      autoAlpha: 1,
      visibility: "visible",
      duration: 1,
      // ease: 'power2.inOut',
      ease: 'none',
    });
  }
  // ## Image Wrapper 2 animate to position 2
  initImageScrollWrapper2 = () => {
    const imageWrapper2 = this.container.querySelector('.image-wrapper-2');
    if (!imageWrapper2) return;
    gsap.set(imageWrapper2, {
      scale: .8,
      y: "-15%",
      // filter: "blur(15px)",
    });
    // wrapper 2 animate to position 2
    gsap.to(imageWrapper2, {
      scrollTrigger: {
        trigger: this.container,
        toggleActions: "play none none reverse",
        start: '-' + OBJECT_SCROLL_DISTANCE + 'px top',
        end: 'top top',
        // markers: true,
        scrub: true,
      },
      scale: 1,
      y: "0%",
      // filter: "blur(0px)",
      duration: 1,
      // ease: 'power2.inOut',
      ease: 'none',
    });
  }
  // ## Image Wrapper 3 animate INTO FOCUS
  initImageScrollWrapper3 = () => {
    const imageWrapper3 = this.container.querySelector('.image-wrapper-3');
    if (!imageWrapper3) return;
    gsap.set(imageWrapper3, {
      scale: .6,
      y: "-25%",
      // filter: "blur(15px)",
    });
    // wrapper 3 animate INTO FOCUS
    gsap.to(imageWrapper3, {
      scrollTrigger: {
        trigger: this.container,
        toggleActions: "play none none reverse",
        start: 'top top',
        end: 'top -' + OBJECT_SCROLL_DISTANCE + 'px',
        // markers: true,
      },
      scale: 1,
      y: "0%",
      // filter: "blur(0px)",
      duration: 1,
      ease: 'power1.inOut',
    });
  }
  // ## Image Wrapper 4 animate OUT
  initImageScrollWrapper4 = (isLast) => {
    const imageWrapper4 = this.container.querySelector('.image-wrapper-4');
    if (!imageWrapper4) return;
    // wrapper 4 animate OUT
    gsap.to(imageWrapper4, {
      scrollTrigger: {
        trigger: this.container,
        toggleActions: "none play reverse none", // LEAVE!
        start: 'top top',
        end: 'top -' + OBJECT_SCROLL_DISTANCE + 'px',
        // markers: true,
        onEnter: () => {
          this.onObjectActive();
        },
        onLeave: () => {
          this.container.classList.add(classNames.OBJECT_HIDING);
          // if last scroll to NEXT CHAPTER LINK
          if (isLast) {
            scrollToTargetForce('.item-nav-next', { duration: .8, offset: 1 });
          }
          this.onObjectLeave();
        },
        onEnterBack: () => {
          this.container.classList.remove(classNames.OBJECT_HIDING);
          this.onObjectVisible();
          this.onObjectActive();
        },
        onLeaveBack: () => {
          this.onObjectLeave();
        }
      },
      scale: 3,
      y: window.innerHeight * 3,
      // filter: "blur(40px)",
      duration: 1,
      ease: 'power2.inOut',
      onComplete: this.onObjectLeaveComplete,
    });
  }
  /**
   * Object Visible
   */
  onObjectVisible = () => {
    this.container.classList.add(classNames.OBJECT_VISIBLE);
  }
  /**
   * Object ACTIVE (current)
   */
  onObjectActive = () => {
    this.descriptionShow();
  }
  /**
   * Object OUT (leave)
   */
  onObjectLeave = () => {
    this.descritpionHide();
    clearTimeout(this.objectInTimeout);
  }
  /**
   * Object OUT (leave complete)
   */
  onObjectLeaveComplete = () => {
    this.container.classList.remove(classNames.OBJECT_VISIBLE);
  }
  // last object leave - scroll to next chapter
  onLastLeave = () => {
    if (document.documentElement.classList.contains("as-in-progress") || !document.documentElement.classList.contains("as-show")) {
      return false;
    }
    const nextChapterLink = document.querySelector('.chapter-nav-next');
    if (nextChapterLink) {
      const url = nextChapterLink.getAttribute('href');
      // RytmWebflow.aswap.openURL(url);
    }
  }
  // ### Show Description ###
  descriptionShow = () => {
    const descrWrapper = this.getDescriptionWrapper();
    if (!descrWrapper) {
      console.warn('No description wrapper found');
    }
    // update subchapter title & year
    this.showSubCh(descrWrapper.querySelector('[data-artobject-subchapter]'));
    // this.showYear(descrWrapper.querySelector('[data-artobject-year]'));
    // get all objectscroll elements
    const list = [...this.container.querySelectorAll('[data-objectscroll-initial]')];
    list.forEach(this.descriptionElementShow);
    clearTimeout(this.descriptionTimeout);
    this.descriptionTimeout = setTimeout(() => {
      descrWrapper.style.display = 'block';
    }, 50);
  }
  // ## Element with objectscroll data SHOW
  descriptionElementShow = (el, index) => {
    const propsInitial = this.getTweenProps(el, 'objectscroll-initial');
    const propsShow = this.getTweenProps(el, 'objectscroll-show');
    if (propsInitial && propsShow) {
      gsap.killTweensOf(el);
      gsap.set(el, { ...propsInitial.tween });
      gsap.to(el, {
        duration: propsShow.time,
        delay: propsShow.delay,
        ...propsShow.tween
      });
    }
  }
  // ### Show SubChapter ###
  showSubCh = (srcEl) => {
    const target = document.querySelector(srcEl.dataset.artobjectSubchapter);
    if (target) {
      target.innerHTML = srcEl.innerHTML;
    }
  }
  // showYear = (srcEl) => {
  //   const target = document.querySelector(srcEl.dataset.artobjectYear);
  //   if (target) {
  //     target.innerHTML = srcEl.innerHTML;
  //   }
  // }
  // ### Hide Description ###
  descritpionHide = () => {
    const descrWrapper = this.getDescriptionWrapper();
    if (!descrWrapper) {
      console.warn('No description wrapper found');
    }
    const list = [...this.container.querySelectorAll('[data-objectscroll-initial]')];
    list.forEach(this.descriptionElementHide);
    clearTimeout(this.descriptionTimeout);
    this.descriptionTimeout = setTimeout(() => {
      descrWrapper.style.display = 'none';
    }, 1500);
  }
  // ## Element with objectscroll data HIDE
  descriptionElementHide = (el, index) => {
    const propsHide = this.getTweenProps(el, 'objectscroll-hide');
    if (propsHide) {
      gsap.killTweensOf(el);
      gsap.to(el, {
        duration: propsHide.time,
        delay: propsHide.delay,
        ...propsHide.tween
      });
    }
  }

  // ### Helpers ####
  getDescriptionWrapper = () => {
    return this.container ? this.container.querySelector('.artobject-list-descr') : null;
  }
  // ### End: Helpers ####

  // data-attribute animations
  // initElementScrollTrigger = (el) => {
  //   const propsInitial = this.getTweenProps(el, 'objectscroll-initial');
  //   const propsShow = this.getTweenProps(el, 'objectscroll-show');
  //   if (propsInitial && propsShow) {
  //     gsap.killTweensOf(el);
  //     gsap.set(el, {...propsInitial.tween});
  //     gsap.to(el, {
  //       scrollTrigger: {
  //         trigger: this.container,
  //         start: 'top top',
  //         end: 'top -' + OBJECT_SCROLL_DISTANCE + 'px',
  //         toggleActions: "play reverse play reverse",
  //         // markers: {startColor: "red", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20},
  //       },
  //       duration: propsShow.time, 
  //       ...propsShow.tween
  //     });
  //   }
  // }
  getTweenProps = (el, name) => {
    const dataAttrName = this.getDataAttributeName(name);
    return RytmWebflow.getWebflowAnimationProps(el.dataset[dataAttrName]);
  }
  // replace data-x with dataX
  getDataAttributeName(name) {
    return name.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
  }
  /**
   * ### End: Scroll Triggers ###
   * ############################
   */

}

export default ObjectListView